import React, {Component, useRef} from "react";
import {graphql} from "gatsby";
import RecipeCard from "../../cards/recipe";
import {Link} from "../../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import Slider from "react-slick";

class BlockUpdate extends Component {
  shouldComponentUpdate() {
    return false
  }
  render() {
    return (<>{ this.props.children }</>)
  }
}

const RecipeSelector = ({title, items, brand, theme}) => {

  const sliderRef = useRef(null)
  const settings = {
    className: "slider variable-width",
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    dots: true,
    autoplay: false,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 5000,
        }
      },
    ]
  }

  return (
    <section className={`recipe-archive ${theme || ''} ${brand} ${brand ? 'recipe-archive--product' : ''} recipe-selector`}>
      <div className='recipe-archive__inner'>
        {title && <h3 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h3>}
        <div className='recipe-archive__items'>
          <BlockUpdate>
            <Slider {...settings} ref={sliderRef}>
              { items?.length > 0 && items.map((el, i) => (
                <Link to={el.permalink} key={i} className='recipe-archive__item' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                  <RecipeCard theme={theme} {...el} />
                </Link>
              ))}
            </Slider>
          </BlockUpdate>
        </div>
      </div>
    </section>
  )
}

export default RecipeSelector

export const query = graphql`
fragment RecipeSelectorProps on DatoCmsRecipeSelector {
  ... on DatoCmsRecipeSelector {
    id
    title
    items {
      originalId
      title
      brand
      excerpt
      tags {
        title
      }
      slug
      permalink
      header
      featureImage {
        ...InternalAssetProps
      }
    }
  }
}
`